/* eslint-disable max-len,indent */
import React, { useContext, useEffect } from 'react';
import { ExperienceContext, useConfigService } from '@thd-nucleus/experience-context';
import { Metadata } from '@thd-olt-component-react/metadata';
import './PrivacyStatement.scss';
import { PrivacyMetadata } from '../PrivacyMetadata';
import { PrivacyStatementContent } from './PrivacyStatementContent';

const metadata = {
  title: 'Privacy and Security Statement – The Home Depot',
  description: 'Customer privacy is important to The Home Depot. Our Privacy and Security Statement '
    + 'provides a summary of the personal information we collect and how we use it, our privacy practices, as well as your choices and rights.',
  canonical: 'https://www.homedepot.com/privacy/privacy-and-security-statement'
};

export const PrivacyStatementHOC = () => {

  const { channel } = useContext(ExperienceContext);
  const revisionDate = useConfigService('revisionDate');

  useEffect(() => {
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('exerciseMyPrivacyRights.static.page-load', {
      pageName: 'privacy and security center>the home depot inc privacy and security statement',
      pageType: 'content',
      primaryCategory: 'privacy and security center',
      subCategory1: 'privacy and security center>the home depot inc privacy and security statement',
      subCategory2: 'privacy and security center>the home depot inc privacy and security statement'
    });
  });

  const handleTableOfContentsChange = (option) => {
    window.location.hash = option.target.value;
  };

  return (
    <>
      <Metadata>
        <PrivacyMetadata
          title={metadata.title}
          description={metadata.description}
          canonical={metadata.canonical}
        />
      </Metadata>
      <PrivacyStatementContent
        channel={channel}
        handleTableOfContentsChange={handleTableOfContentsChange}
        revisionDate={revisionDate}
      />
    </>
  );
};
